export const actions = { 
  UPDATE_ERROR: 'UPDATE_ERROR',
}

export const updateError = (errorMessage) => ({
  type: actions.UPDATE_ERROR,
  data: errorMessage
})